import { Navigate } from 'react-router-dom';
import Reports from '../../../modules/superAdmin/Reports';
import Settings from '../../../modules/superAdmin/Settings';
import TemporaryOperatingInstruction from '../../../modules/superAdmin/TemporaryOperatingInstruction';
import TempOperatingInstructionDetails from '../../../modules/superAdmin/TemporaryOperatingInstruction/TempOperatingInstructionDetails';
import NotificationList from '../../../modules/superAdmin/Settings/NotificationList';
import UserInfo from '../../../modules/superAdmin/Settings/UserInfo';
import PasswordSecurity from '../../../modules/superAdmin/Settings/PasswordSecurity';
import PrivacyPolicy from '../../../modules/superAdmin/Settings/PrivacyPolicy';

const routes = [
  {
    path: '/TemporaryOperatingInstruction',
    element: <TemporaryOperatingInstruction />,
  },
  {
    path: '/TemporaryOperatingInstruction/:id',
    element: <TempOperatingInstructionDetails />,
  },
  {
    path: '/Report',
    element: <Reports />,
  },
  {
    path: '/settings',
    element: <Settings />,
    children: [
      //{ index: true, element: <UserInfo /> },
      { path: 'user-info', element: <UserInfo /> },
      { path: 'password', element: <PasswordSecurity /> },
      { path: 'notifications', element: <NotificationList /> },
      { path: 'privacy-policy', element: <PrivacyPolicy /> },
    ],
  },
  {
    path: '/notifications',
    element: <NotificationList />,
  },
  // 🚫 Catch all undefined or restricted routes
  {
    path: '*',
    element: <Navigate to="/login" replace />,
  },
];
export default routes;
